<template>
  <div class="feedback-video-carousel py-20">
    <Splide :options="options" ref="feedvideo">
      <SplideSlide v-for="(video, index) in videos" :key="video.id">
        <div class="bg-white p-8 relative m-auto" style="width:90%;">
          <p class="text-2xl text-left"> {{ video.title.rendered }}</p>
          <div class="video-container" :ref="`playerContainer${index}`"></div>
          <div class="video-overlay" @click="playVideo(index)"></div>
        </div>

      </SplideSlide>
    </Splide>
  </div>
</template>

<script>

import { ref, onMounted } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { getFeedbacks } from '../../scripts/getAxios';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import YouTubePlayer from 'youtube-player';




export default {
  name: "feedbacks",
  components: {
    Splide,
    SplideSlide,

  },
  setup() {
    const videos = ref([]);
    const players = ref([]);
    const yt = ref(null)
    const feedvideo = ref(null);
    const options = {
      breakpoints: {
        640: {
          perPage: 1, // Su schermi con larghezza <= 640px, mostra una sola slide
        },
        768: {
          perPage: 2, // Su schermi con larghezza <= 768px, mostra 2 slide
        },
        1024: {
          perPage: 2, // Su schermi con larghezza <= 1024px, mostra 3 slide
        },
      },
      rewind: true,
      perPage: 3,
      pagination: false,
      arrow: true,
      autoplay: true
    }

    const importFeedbacks = async () => {
      try {
        await getFeedbacks(`${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/feedbacks`).then(response => {
          videos.value.push(...response.data)
        })
      } catch (error) {
        console.error('Errore durante il caricamento dei feedback:', error);
      }
    }




    const extractVideoId = (url) => {
      // Eseguire l'estrazione dell'ID utilizzando una espressione regolare
      const match = url.match(/(?:\?v=|\/embed\/|\/\d+\/|\/vi?\/|https?:\/\/(?:www\.)?youtube\.com\/playlist\?(?:.+&)?v=|youtu\.be\/)([^\?&"'>]+)/);
      // Se c'è una corrispondenza, restituisci l'ID del video
      if (match && match[1]) {
        return match[1];
      } else {
        // Se non c'è corrispondenza, restituisci null
        return null;
      }
    }
    const playVideo = (index) => {
      const player = players.value[index];
      if (player) {
        players.value.forEach((p, i) => {
          if (i !== index && p) {
            p.stopVideo();
          }
        });

        player.getPlayerState().then((playerState) => {
          if (playerState === 1) { // Verifica se il video è attualmente in riproduzione
            player.pauseVideo(); // Ferma la riproduzione del video
          } else {
            player.playVideo(); // Avvia la riproduzione del video
          }
        }).catch((error) => {
          console.error('Errore durante il recupero dello stato del video:', error);
        });
      }
    };

    onMounted(async () => {
      await importFeedbacks()
      videos.value.map((video, index) => {
        const playerContainer = document.querySelectorAll('.video-container')[index];
       
        const player = YouTubePlayer(playerContainer, {
          videoId: extractVideoId(video.video_embed),
        });
        players.value.push(player);
      });

    })


    return {
      videos,
      feedvideo,
      options,
      playVideo

    };
  },
};
</script>

<style lang="scss" scoped>
.feedback-video-carousel{
  iframe.video-container {
    width: 100%;
  }
  .video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0);
  /* Overlay trasparente */
}
} 






.skeleton-carousel {
  display: flex;
  justify-content: center;
}

.skeleton-slide {
  width: 300px;
  height: 200px;
  background-color: #f0f0f0;
  margin: 0 10px;
}

.feedback-carousel {

  margin: 0 auto;

  .feedback-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
  }

  .splide__arrow {
    background-color: rgba(255, 255, 255, 0.7);
    color: #333;
    border: none;
    padding: 10px 20px;
    border-radius: 50%;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
    transition: background-color 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }

    &--prev {
      left: 20px;
    }

    &--next {
      right: 20px;
    }
  }

  .star-rating {
    display: inline-block;
  }

  .star-rating .star {
    color: #FFD700;
    font-size: 18px;
  }

  .star-rating .star--empty {
    color: #ccc;
  }
}
</style>